import { renderPlpPage } from './product-listing-page';

renderPlpPage();
